import React, { useState, useEffect, useRef, useContext } from "react";
import productHandler from "./../Functions/product-handler";
// import { async } from 'q';
import { toast } from "react-toastify";
import productPlaceholder from "../Assets/images/product_placeholder.png";
import CreatableSelect from "react-select/creatable";
import { GlobalSearchContext } from "../Components/Viewer/context";
import SpinnerLoader from "../Common/SpinnerLoader";

const colourStyles = {
  option: (styles, { isFocused }) => {
    return {
      ...styles,
      backgroundColor: isFocused ? "transparent" : null,
      color: "#000",
    };
  },
};

const Container = ({
  multiProducts,
  pdf,
  cartCounterHandler,
  buttonType,
  collectionName,
  collectionDescription,
}) => {
  const [totalPrice, setTotalPrice] = useState(0);
  const [readMore, setReadMore] = useState({});
  // const [tagOptions, setTagOptions] = useState([]);
  const [collectionproductloader, setcollectionproduct] = useState(false);
  const [showMultiProducts, setShowMultiProducts] = useState(multiProducts);
  const [addedItem, setAddedItem] = useState(null);
  const [addedRelated, setAddedRelated] = useState({});
  const [priceValue] = useState(
    localStorage.getItem("uiPriceField") || "Price"
  );
  const [TotalpriceValue] = useState(
    localStorage.getItem("priceValue") || "Total Price"
  );
  const [belowTotalMrp] = useState(localStorage.getItem("belowTotalMrp") || "");
  const cart = useRef();
  const { tagOptions, createTag } = useContext(GlobalSearchContext);

  const handleTagChangeChildProduct = (tag) => {
    setcollectionproduct(true);
    let newMultiProducts = [...multiProducts];
    for (const x in multiProducts) {
      newMultiProducts[x].tag = tag["label"];
    }
    setShowMultiProducts(newMultiProducts);
    setcollectionproduct(false);
  };

  // const createTag = (tag) => {
  //     setTagOptions([...tagOptions, { label: tag, value: '' }])
  // };

  const thead = [
    {
      name: "_img",
      text: "Image",
    },

    {
      name: "_product",
      text: "Product",
    },

    {
      name: "_desc",
      text: "Product Description",
    },

    {
      name: "_qty",
      text: "Qty.",
    },

    {
      name: "_price",
      text: priceValue,
    },
    {
      name: "total_price",
      text: TotalpriceValue,
      BelloWText: belowTotalMrp,
    },

    {
      name: "_action",
      text: " ",
    },
  ];

  const handleReadMore = (id) => {
    setReadMore({
      ...readMore,
      [id]: !readMore[id],
    });
  };

  useEffect(() => {
    cart.current = new productHandler(pdf);
  }, [pdf]);

  useEffect(() => {
    let Total = 0;
    for (const x in multiProducts) {
      Total += multiProducts[x].product_price * multiProducts[x].pQunatity;
    }
    setTotalPrice(Total);
  }, [totalPrice]);

  const addToCart = async (
    sku_code,
    name,
    pQuantity,
    tag,
    isMandatory,
    ManProducts = [],
    parentId,
    fullItem = null,
    isRelated = false
  ) => {
    try {
      // Add main product
      const res = await cart.current.AddToCart(
        sku_code,
        pQuantity,
        tag,
        false,
        0
      );

      if (!res?.data?.success) {
        toast.error("Something went wrong!", {
          className: "toast-style",
        });
        return;
      }

      if (isRelated) {
        const relatedKey = Array.isArray(sku_code) ? sku_code[0] : sku_code;
        setAddedRelated((prev) => ({ ...prev, [relatedKey]: true }));
        // setTimeout(() => {
        //   setAddedRelated((prev) => {
        //     const next = { ...prev };
        //     delete next[relatedKey];
        //     return next;
        //   });
        // }, 500);
      } else {
        toast.success("Added to Cart successfully", {
          className: "toast-style",
        });
      }

      // Optional: use newly created cart item id
      const addedCartId = res?.data?.data?._id || parentId;

      // Add mandatory products
      if (ManProducts?.length > 0) {
        await Promise.all(
          ManProducts.map(async (m) => {
            try {
              await cart.current.AddToCart(
                [m.sku_code],
                m.quantity,
                "",
                true,
                addedCartId
              );
            } catch (err) {
              console.error(
                `Failed to add mandatory product: ${m.sku_code}`,
                err
              );
            }
          })
        );
      }

      // Hit after ALL products are added
      await cartCounterHandler.fetchCartCounterData();

      if (fullItem && !isRelated) setAddedItem(fullItem);

    } catch (error) {
      console.error(error);

      toast.error("Something went wrong!", {
        className: "toast-style",
      });
    }
  };

  const handleAllCollectionCart = async () => {
    try {
      for (const x in multiProducts) {
        const res = await cart.current.AddToCart(
          [multiProducts[x]?.sku_code],
          multiProducts[x]?.pQunatity,
          multiProducts[x]?.tag
        );
        const error = res.data.success;

        if (!error) {
          toast.success("something went wrong!", {
            className: "toast-style",
          });
        } else {
          if (x === "0") {
            toast.success("collection added to cart successfully", {
              className: "toast-style",
            });
          }
        }
      }
      cartCounterHandler.fetchCartCounterData();
    } catch (error) {
      toast.success("something went wrong!", {
        className: "toast-style",
      });
    }
  };
  return (
    <>
      {collectionproductloader ? (
        <SpinnerLoader />
      ) : showMultiProducts && showMultiProducts.length > 0 ? (
        <>
          {buttonType === "3" ? (
            <div className="multi-products">
              <div className="collectionDetails">
                <div className="collectionNameAndPrice">
                  <h4>{collectionName}</h4>
                  <h5>Rs. {Number(totalPrice).toFixed(2)}</h5>
                </div>
                <div className="collectionDescAndAddCart">
                  <div className="collectionDesc">
                    <p>{collectionDescription}</p>
                  </div>
                  <button
                    className="add-cart-collection"
                    onClick={handleAllCollectionCart}
                  >
                    Add collection to cart
                  </button>
                </div>
                <div className="CollectionTagParent">
                  <div className="CollectionTagMain">
                    <CreatableSelect
                      // value={{ label: product.tag, value: '' }}
                      allowCreateWhileLoading={true}
                      placeholder="Add Tag"
                      options={tagOptions}
                      styles={colourStyles}
                      onCreateOption={(tag) => createTag(tag)}
                      onChange={(selectedOption) =>
                        handleTagChangeChildProduct(selectedOption)
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="collectionProducts">
                <h4>Collection Products</h4>
              </div>
              <div className="displayNoneMobile">
                <table cellPadding="5">
                  <thead>
                    <tr>
                      {thead.map((th, index) => (
                        <th key={index}>
                          {th.text}
                          {th.BelloWText && (
                            <p className="bellowTextTotalMrp">
                              {th.BelloWText}
                            </p>
                          )}
                        </th>
                      ))}
                    </tr>
                  </thead>

                  <tbody>
                    {showMultiProducts.map((item, index) => (
                      <>
                        <tr key={index}>
                          <td>
                            <span>
                              <img
                                src={item?.product_image || productPlaceholder}
                                alt={item?.product_name}
                              />
                            </span>
                          </td>
                          <td>{item?.product_name}</td>
                          <td>
                            {item?.product_description}
                            <br />
                            {item.sku_code}
                          </td>
                          <td>{item?.pQunatity ? item?.pQunatity : 1}</td>
                          <td>{item?.product_price}</td>
                          <td>
                            {item?.product_price *
                              (item?.pQunatity ? item?.pQunatity : 1)}
                          </td>
                          <td>
                            <button
                              className="add-cart"
                              onClick={(e) =>
                                addToCart(
                                  [item.sku_code],
                                  item.product_name,
                                  item?.pQunatity ? item?.pQunatity : 1,
                                  item?.tag
                                )
                              }
                            >
                              Add to cart
                            </button>
                          </td>
                        </tr>
                        {item?.child_sku?.length > 0 &&
                          item.child_sku.map((item, i) => (
                            <tr key={i}>
                              <td>
                                <span>
                                  <img
                                    src={
                                      item.product_image || productPlaceholder
                                    }
                                    alt={item.product_name}
                                  />
                                </span>
                              </td>
                              <td>{item.product_name}</td>
                              <td>
                                {item.product_description}
                                <br />
                                {item.sku_code}
                              </td>
                              <td>{item?.pQunatity ? item?.pQunatity : 1}</td>
                              <td>{item.product_price}</td>
                              <td>
                                {item?.product_price *
                                  (item?.pQunatity ? item?.pQunatity : 1)}
                              </td>
                              <td>
                                <button
                                  className="add-cart"
                                  onClick={(e) =>
                                    addToCart(
                                      [item.sku_code],
                                      item.product_name,
                                      item?.tag
                                    )
                                  }
                                >
                                  Add to cart
                                </button>
                              </td>
                            </tr>
                          ))}
                      </>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* mobile Cart start */}
              <div className="mobileCartsectionContainerCollection">
                {showMultiProducts?.map((item, index) => {
                  return (
                    <React.Fragment key={index}>
                      <div key={index} className="mobilecartMain">
                        <div className="productImageSec">
                          <div className="productImageCart">
                            <img
                              src={item?.product_image || productPlaceholder}
                              alt={item?.product_name}
                            />
                          </div>
                        </div>
                        <div className="productDetailsSec">
                          <div className="productDetailsCartMain">
                            <div className="productNameCross">
                              <div className="productName">
                                <h3>{item?.product_name}</h3>
                                <>
                                  {item?.product_description?.length > 50 ? (
                                    <>
                                      {!readMore[item?.sku_code] ? (
                                        <p>
                                          {`${item?.product_description?.slice(
                                            0,
                                            50
                                          )}...`}
                                          <b
                                            className="cursorPointer"
                                            onClick={() =>
                                              handleReadMore(item?.sku_code)
                                            }
                                          >
                                            Read more
                                          </b>
                                        </p>
                                      ) : (
                                        <p>
                                          {`${item?.product_description?.slice(
                                            0,
                                            200
                                          )} `}
                                          <b
                                            className="cursorPointer"
                                            onClick={() =>
                                              handleReadMore(item?.sku_code)
                                            }
                                          >
                                            {" "}
                                            Read less
                                          </b>
                                        </p>
                                      )}
                                    </>
                                  ) : (
                                    <p> {item.product_description} </p>
                                  )}
                                </>
                              </div>
                            </div>
                            <div className="productPriceandQuantity">
                              <h3>
                                Qty. {item?.pQunatity ? item?.pQunatity : 1}
                              </h3>
                            </div>
                            <div className="productPriceCart MobilePricePerUnit">
                              <h3>{priceValue}</h3>
                              <p className="marginBottom0">{`${item?.product_price}`}</p>
                            </div>
                            {/* <div className="productPriceCart MobilePricePerUnit">
                                                                    <h3>{TotalpriceValue}</h3>
                                                                    <p className='marginBottom0'>{`${item?.product_price * (item?.pQunatity ? item?.pQunatity : 1)}`}</p>
                                                                </div> */}
                            <div className="productPriceandQuantity">
                              <div className="productPriceCart">
                                <h3 className="marginBottom0">{`${item?.product_price *
                                  (item?.pQunatity ? item?.pQunatity : 1)
                                  }`}</h3>
                                <span>({TotalpriceValue})</span>
                                <br />
                                <span>{belowTotalMrp}</span>
                              </div>
                              <div className="productQuantity">
                                <button
                                  className="add-cart-collection"
                                  onClick={(e) =>
                                    addToCart(
                                      [item.sku_code],
                                      item.product_name,
                                      item?.pQunatity ? item?.pQunatity : 1,
                                      item?.tag
                                    )
                                  }
                                >
                                  Add to cart
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {item?.child_sku?.map((item, i) => (
                        <div key={i} className="mobilecartMain">
                          <div className="productImageSec">
                            <div className="productImageCart">
                              <img
                                src={item?.product_image || productPlaceholder}
                                alt={item?.product_name}
                              />
                            </div>
                          </div>
                          <div className="productDetailsSec">
                            <div className="productDetailsCartMain">
                              <div className="productNameCross">
                                <div className="productName">
                                  <h3>{item?.product_name}</h3>
                                  <>
                                    {item?.product_description?.length > 50 ? (
                                      <>
                                        {!readMore[item?.sku_code] ? (
                                          <p>
                                            {`${item?.product_description?.slice(
                                              0,
                                              50
                                            )}...`}
                                            <b
                                              className="cursorPointer"
                                              onClick={() =>
                                                handleReadMore(item?.sku_code)
                                              }
                                            >
                                              Read more
                                            </b>
                                          </p>
                                        ) : (
                                          <p>
                                            {`${item?.product_description?.slice(
                                              0,
                                              200
                                            )} `}
                                            <b
                                              className="cursorPointer"
                                              onClick={() =>
                                                handleReadMore(item?.sku_code)
                                              }
                                            >
                                              {" "}
                                              Read less
                                            </b>
                                          </p>
                                        )}
                                      </>
                                    ) : (
                                      <p> {item.product_description} </p>
                                    )}
                                  </>
                                </div>
                              </div>
                              <div className="productPriceandQuantity">
                                <h3>
                                  Qty. {item?.pQunatity ? item?.pQunatity : 1}
                                </h3>
                              </div>
                              <div className="productPriceandQuantity">
                                <div className="productPriceCart">
                                  <h3 className="marginBottom0">{`Rs. ${item?.product_price}`}</h3>
                                  <span>({priceValue})</span>
                                </div>
                                <div className="productQuantity">
                                  <button
                                    className="add-cart-collection"
                                    onClick={(e) =>
                                      addToCart(
                                        [item.sku_code],
                                        item.product_name,
                                        item?.pQunatity ? item?.pQunatity : 1,
                                        item?.tag
                                      )
                                    }
                                  >
                                    Add to cart
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </React.Fragment>
                  );
                })}
              </div>
              {/* mobile Cart end */}
            </div>
          ) : addedItem ? (
            <div className="atcPopup">
              <div className="atcSuccessPanel">
                <div className="atcSuccessTopRow">
                  <span className="atcSuccessIcon">&#10003;</span>
                  <h3 className="atcSuccessTitle">Added to Cart successfully</h3>
                </div>
                <div className="atcSuccessProduct">
                  <div className="atcSuccessImg">
                    <img
                      src={addedItem?.product_image || productPlaceholder}
                      alt={addedItem?.product_name}
                    />
                  </div>
                  <div className="atcSuccessInfo">
                    <h4>{addedItem?.product_name}</h4>
                    {addedItem?.MandatoryProducts?.length > 0 && (
                      <p className="atcMandatoryCount">
                        +{addedItem.MandatoryProducts.length} mandatory products
                      </p>
                    )}
                  </div>
                </div>
              </div>
              {addedItem?.child_sku?.length > 0 && (
                <div className="atcRelatedSection">
                  <h3 className="atcRelatedTitle">Related Products</h3>
                  <div className="atcRelatedList">
                    {addedItem.child_sku.map((c, i) => {
                      const isAdded = addedRelated[c.sku_code];
                      return (
                        <div className="atcRelatedItem" key={i}>
                          <div className="atcRelatedImg">
                            <img
                              src={c?.product_image || productPlaceholder}
                              alt={c?.product_name}
                            />
                          </div>
                          <div className="atcRelatedInfo">
                            <h4>{c?.product_name}</h4>
                            <p className="atcSku">{c?.sku_code}</p>
                            <p className="atcDesc">{c?.product_description}</p>
                          </div>
                          <div className="atcRelatedPrice">
                            &#8377;{c?.product_price}
                          </div>
                          <button
                            className={`btn atcAddBtn small${
                              isAdded ? " added" : ""
                            }`}
                            disabled={isAdded}
                            onClick={() =>
                              addToCart(
                                [c.sku_code],
                                c.product_name,
                                c?.pQunatity ? c.pQunatity : 1,
                                "",
                                false,
                                [],
                                null,
                                c,
                                true
                              )
                            }
                          >
                            {isAdded ? (
                              <>
                                <span className="atcCheck">&#10003;</span> Added
                              </>
                            ) : (
                              "Add to Cart"
                            )}
                          </button>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="atcPopup">
              {showMultiProducts?.map((item, index) => {
                const mainQty = item?.pQunatity ? item.pQunatity : 1;
                const mandatoryTotal = (item?.MandatoryProducts || []).reduce(
                  (acc, m) =>
                    acc +
                    Number(m?.product_price || 0) *
                      Number(m?.quantity || 1),
                  0
                );
                const grandTotal =
                  Number(item?.product_price || 0) * mainQty + mandatoryTotal;
                return (
                  <div className="atcProductSection" key={index}>
                    <div className="atcHeader">
                      <h2 className="atcHeaderTitle">Add to Cart</h2>
                    </div>
                    <div className="atcMainProduct">
                      <div className="atcMainImg">
                        <img
                          src={item?.product_image || productPlaceholder}
                          alt={item?.product_name}
                        />
                      </div>
                      <div className="atcMainInfo">
                        <h4 className="atcMainName">{item?.product_name}</h4>
                        <p className="atcSku">{item?.sku_code}</p>
                        <p className="atcDesc">{item?.product_description}</p>
                        <p className="atcMainPrice">
                          &#8377;{item?.product_price}
                          <span className="atcPriceSuffix"> /piece</span>
                        </p>
                      </div>
                    </div>
                    {item?.MandatoryProducts?.length > 0 && (
                      <>
                        <p className="atcMandatoryNote">
                          This product has {item.MandatoryProducts.length}{" "}
                          mandatory products which will be added to the cart
                          along with the selected product.
                        </p>
                        <div className="atcMandatoryList">
                          {item.MandatoryProducts.map((m, i) => (
                            <div className="atcMandatoryItem" key={i}>
                              <div className="atcMandatoryImg">
                                <img
                                  src={m?.product_image || productPlaceholder}
                                  alt={m?.product_name}
                                />
                              </div>
                              <div className="atcMandatoryInfo">
                                <h4>{m?.product_name}</h4>
                                <p className="atcSku">{m?.sku_code}</p>
                                <p className="atcDesc">
                                  {m?.product_description}
                                </p>
                              </div>
                              <div className="atcMandatoryPrice">
                                <span className="amt">
                                  &#8377;{m?.product_price}
                                </span>
                                <span className="suffix"> /piece</span>
                              </div>
                            </div>
                          ))}
                        </div>
                      </>
                    )}
                    {item?.child_sku?.length > 0 && (
                      <div className="atcRelatedSection">
                        <h3 className="atcRelatedTitle">Related Products</h3>
                        <div className="atcRelatedList">
                          {item.child_sku.map((c, i) => {
                            const isAdded = addedRelated[c.sku_code];
                            return (
                              <div className="atcRelatedItem" key={i}>
                                <div className="atcRelatedImg">
                                  <img
                                    src={
                                      c?.product_image || productPlaceholder
                                    }
                                    alt={c?.product_name}
                                  />
                                </div>
                                <div className="atcRelatedInfo">
                                  <h4>{c?.product_name}</h4>
                                  <p className="atcSku">{c?.sku_code}</p>
                                  <p className="atcDesc">
                                    {c?.product_description}
                                  </p>
                                </div>
                                <div className="atcRelatedPrice">
                                  &#8377;{c?.product_price}
                                </div>
                                <button
                                  className={`btn atcAddBtn small${
                                    isAdded ? " added" : ""
                                  }`}
                                  disabled={isAdded}
                                  onClick={() =>
                                    addToCart(
                                      [c.sku_code],
                                      c.product_name,
                                      c?.pQunatity ? c.pQunatity : 1,
                                      "",
                                      false,
                                      [],
                                      null,
                                      c,
                                      true
                                    )
                                  }
                                >
                                  {isAdded ? (
                                    <>
                                      <span className="atcCheck">&#10003;</span>{" "}
                                      Added
                                    </>
                                  ) : (
                                    "Add to Cart"
                                  )}
                                </button>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                    <div className="atcBottomBar">
                      <div className="atcGrandTotal">
                        &#8377;{grandTotal}
                        <span className="atcPriceSuffix"> /piece</span>
                      </div>
                      <button
                        className="btn atcAddBtn"
                        onClick={() =>
                          addToCart(
                            [item.sku_code],
                            item.product_name,
                            mainQty,
                            "",
                            false,
                            item?.MandatoryProducts || [],
                            item.products_id,
                            item
                          )
                        }
                      >
                        Add to Cart
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </>
      ) : (
        <h3 style={{ textAlign: "center" }}> No Items</h3>
      )}
    </>
  );
};

export default Container;
